<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Player List<span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">


				<button class="clearFilterBtn" (click)="clear()">
					<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
					<span>Clear All</span>
				</button>
				<p-dropdown inputId="role" [autoDisplayFirst]="false" [options]="roleArray" [filter]="true"
					(onChange)="onChangeRole($event)" [(ngModel)]="selectedRole" placeholder="Select Role"
					optionLabel="rolename" [showClear]="true"></p-dropdown>
				<p-button (click)="op.toggle($event)" label="User List Filters" icon="pi pi-angle-down"
					class="userFilterbtn"></p-button>


				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>

			</div>
		</div>
		<div class="mainDivBody">
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="p2-table-columns show-columns" #dt [value]="userlist" [paginator]="true" [rows]="10"
						[lazy]="true" (onLazyLoad)="loadUsers($event)" [totalRecords]="totalRecords" [loading]="loading"
						[rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">

						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="firstName" class="NameTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										First Name
										<p-sortIcon field="firstName"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="lastName" class="lastNameTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Name
										<p-sortIcon field="lastName"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gender" class="genderTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Gender
										<p-sortIcon field="gender"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="age" class="AgeTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Age
										<p-sortIcon field="gender"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="isAadharVerified" class="isAadharVerifiedTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Age Verification
										<p-sortIcon field="isAadharVerified"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="isPassportVerified" class="isPassportVerifiedTd"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Passport Verification
										<p-sortIcon field="isPassportVerified"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="mobile" class="mobileTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Mobile Number
										<p-sortIcon field="mobile"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="email" class="emailTD"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Email Id
										<p-sortIcon field="email"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="dob" class="dobTd"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										DOB
										<p-sortIcon field="dob"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="city" class="cityTd"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										City
										<p-sortIcon field="city"></p-sortIcon>
									</div>
								</th>
								<!-- <th pSortableColumn="weddingDate" class="col-width">
							<div class="p-d-flex p-jc-between p-ai-center">
								Wedding Date
								<p-sortIcon field="weddingDate"></p-sortIcon>
							</div>
						</th> -->
								<!-- <th pSortableColumn="updated_at" class="col-width Modificationdatetd" >
							<div class="p-d-flex p-jc-between p-ai-center">
								Modification Date
								<p-sortIcon field="updated_at"></p-sortIcon>
							</div>
						</th> -->
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th class="actionTD p-frozen-column">
									Action
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="firstName" class="NameTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'firstName', 'contains')"
										[value]="dt.filters['firstName'] ? dt.filters['firstName'].value : ''" />
								</th>
								<th [ngSwitch]="lastName" class="lastNameTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'lastName', 'contains')"
										[value]="dt.filters['lastName'] ? dt.filters['lastName'].value : ''" />
								</th>
								<th [ngSwitch]="gender" class="genderTd">
									<p-dropdown #pDropDownId1 [options]="genders" appendTo="body"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'gender', 'equals')"
										styleClass="p-column-filter" placeholder="Select Gender" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="gender" class="AgeTd">
									<p-multiSelect #pMultiSelectId [filter]="false" display="chip" [showClear]="false"
										[options]="ageGroupList" [showToggleAll]="false" [showClear]="true"
										appendTo="body"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'ageGroup', 'equals')"
										styleClass="p-column-filter" placeholder="Select Age Group">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-multiSelect>
								</th>
								<th [ngSwitch]="gender" class="isAadharVerifiedTd">
									<p-dropdown #pDropDownId2 [options]="ageVerificationStatuses" appendTo="body"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'ageVerificationStatus', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="gender" class="isPassportVerifiedTd"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-dropdown #pDropDownId [options]="passportVerificationStatuses" appendTo="body"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'passportVerificationStatus', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="mobile" class="mobileTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobile', 'contains')"
										[value]="dt.filters['mobile'] ? dt.filters['mobile'].value : ''" />
								</th>
								<th [ngSwitch]="email" class="emailTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'email', 'contains')"
										[value]="dt.filters['email'] ? dt.filters['email'].value : ''" />
								</th>
								<th [ngSwitch]="dob" class="dobTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'dob', 'dateIs')"
										[showIcon]="true" yearNavigator="true" yearRange="1950:2050"
										[(ngModel)]="dcalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="cityname" class="cityTd"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-dropdown #pDropDownId3 [options]="citylist" [filter]="true" appendTo="body"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'cityname', 'equals')"
										styleClass="p-column-filter" placeholder="Select City" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<!-- <th [ngSwitch]="weddingDate" class="">
							<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'weddingDate', 'dateIs')"
								[showIcon]="true" [(ngModel)]="wdcalvalue"></p-calendar>
						</th> -->
								<!-- <th [ngSwitch]="updated_at" class="Modificationdatetd">
							<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
								[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar>
						</th> -->
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId4 [options]="statuses" [(ngModel)]="defaultStatus"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th class="actionTD p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
									<!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-user>
							<tr class="p-selectable-row">
								<td class="NameTD">
									{{user.firstName}}
								</td>
								<td class="lastNameTD">
									{{user.lastName}}
								</td>
								<td class="genderTd">
									{{user.gender}}
								</td>
								<td class="AgeTd">
									{{user.age}}
								</td>
								<td class="isAadharVerifiedTd">
									{{ (user.isAadharVerified) ? 'Completed' : 'Pending' }}
								</td>
								<td class="isPassportVerifiedTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{ (user.isPassportVerified) ? 'Completed' : 'Pending' }} &nbsp;
									<i class="pi pi-info-circle" style="color: red;"
										(click)="showPassportRejectionReasonList(user)"
										*ngIf="user.rejectedDocuments.length !== 0"></i>
								</td>
								<td class="mobileTd">
									{{user.mobileNumber}}
								</td>
								<td class="emailTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{user.email}}
								</td>
								<td class="dobTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{user.dob}}
								</td>
								<td class="cityTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{user.cityname}}
								</td>
								<!-- <td>
							{{user.weddingDate | date:'d/M/yyyy'}}
						</td> -->
								<!-- <td class="Modificationdatetd">
							{{user.updated_at | date:'d-M-yyyy'}}
						</td> -->
								<td class="text-center statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="user.status" (onChange)="changeStatus(user)"
											class="d-flex"></p-inputSwitch>
										<div class="label activeText" *ngIf="user.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!user.status">
											Inactive
										</div>
									</div>

									<!-- <p-inputSwitch [(ngModel)]="user.status"
										(onChange)="changeStatus(user)"></p-inputSwitch> -->
								</td>
								<td class="actionTD p-frozen-column">
									<ul class="actionList">
										<li>
											<button (click)="editUser(user.id)" class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="deleteUser(user)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
										<li>
											<p-splitButton icon="pi pi-ellipsis-h" [model]="user.items" appendTo="body"
												styleClass="moreBtn" pTooltip="More Options " tooltipPosition="bottom"
												(onClick)="listMenus(user.id)"></p-splitButton>
										</li>
									</ul>

									<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewUser(user.id)"></button> -->
									<!-- <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
								(click)="editUser(user.id)" pTooltip="Edit Player " tooltipPosition="bottom"></button>
							<button pButton pRipple icon=" pi pi-wallet" class="p-button-rounded p-button-info  p-mr-2"
								(click)="userWallet(user.id)" pTooltip="Player Wallet History"
								tooltipPosition="bottom"></button>
							<button pButton pRipple icon="pi pi-history"
								class="p-button-rounded p-button-warning p-mr-2" pTooltip="Player Schedule List"
								tooltipPosition="bottom" (click)="userscheduleList(user.id)"></button>
							<button pButton pRipple icon="pi pi-flag" class="p-button-rounded p-button-secondry p-mr-2"
								(click)="	(user.id)" pTooltip="Player Tournament Registration"
								tooltipPosition="bottom"></button>
							<button pButton pRipple icon="pi pi-home" class="p-button-rounded p-button-help p-mr-2"
								(click)="userAddressLog(user.id)" pTooltip="Player Address Log"
								tooltipPosition="bottom"></button>
							<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2 p-mt-2"
								(click)="deleteUser(user)" pTooltip="Delete User"
								tooltipPosition="bottom"></button>
							<button pButton pRipple icon="pi pi-chart-line" class="p-button-rounded p-button-help p-mr-2 p-mt-2"
							(click)="rankinggList(user.id)" pTooltip="Ranking List" tooltipPosition="bottom"></button>
							<button pButton pRipple icon="pi pi-user" class="p-button-rounded p-button-secondary p-mr-2"
							(click)="opponentList(user.id)" pTooltip="Opponent List" tooltipPosition="bottom"></button>
							<button pButton pRipple icon="pi pi-verified" class="p-button-rounded p-button-success p-mr-2"  pTooltip="User KYC"
							tooltipPosition="bottom"
							(click)="userKyc(user.id)"></button> -->
									<!---split button div--->
									<!-- <div class="main-action-button"> -->
									<!-- <button pButton pRipple icon="pi pi-pencil"
											class="p-button-rounded p-button-success p-mr-2" (click)="editUser(user.id)"
											pTooltip="Edit Player " tooltipPosition="bottom"></button> -->
									<!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2 p-mt-0"
								(click)="deleteUser(user)" pTooltip="Delete User"
								tooltipPosition="bottom"></button>  -->
									<!-- <p-splitButton icon="pi pi-ellipsis-h" [model]="user.items" appendTo="body"
											styleClass="p-button-warning" pTooltip="More Options "
											tooltipPosition="bottom" (onClick)="listMenus(user.id)"></p-splitButton> -->

									<!-- </div> -->

								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="9">No Register Player found.</td>
							</tr>
						</ng-template>
						<!-- <ng-template pTemplate="summary">
							<div class="p-d-flex p-ai-center p-jc-between">
								In total there are {{totalRecords }} Register Player.
							</div>
						</ng-template> -->
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>

<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
<p-dialog header="Document Approve" [(visible)]="paymentType" [modal]="true" [style]="{ width: '541px'}"
	[draggable]="false" [resizable]="false" class="backend-modal" (onHide)="onDocumentmodalModalClose()"
	id="approveModal">
	<form [formGroup]="approveUpdateForm">
		<div class=" mainform mt-3">
			<div class="">
				<label for="comment">
					Select Document Type <span class="mandatory-fields">*</span>
				</label>
				<div class="">
					<p-dropdown formControlName="type" [options]="methods" [showClear]="true"
						[ngClass]="{'is-invalid': submitted && f.type.errors }" placeholder="Select Document Type"
						optionLabel="name" appendTo="body" [filter]="true" (onClear)="onDropdownClear()">
					</p-dropdown>
					<div *ngIf="submitted && f.type.errors" style="margin-top: 5px;" class="invalid-feedback">
						<div *ngIf="f.type.errors.required">Document Type is required</div>
					</div>
				</div>
			</div><br>
			<div class="uploadBtn" *ngIf="documentData.length === 0; else f2">
				<div class="subTitleLable">
					<h4>Upload Document</h4>
				</div>
				<div class="">
					<div class="">
						<p-fileUpload chooseLabel="Upload" #fileUpload name="myfile[]" maxFileSize="{{imageSize}}"
							customUpload="true" (uploadHandler)="picUploader($event)" accept="image/*" auto="auto"
							(onRemove)="removeFile()"
							[ngClass]="{'is-invalid': submitted && f.image.errors }"></p-fileUpload>
						<div *ngIf="submitted && f.image.errors" class="invalid-feedback">
							<div *ngIf="f.image.errors.required">Please Upload a file.</div>
						</div>
					</div>
				</div>
			</div>
			<ng-template #f2>
				<div class="position-relative cursor-pointer w-100" (click)="openImagePreview(documentData[0]?.image)">
					<img class="uploadedImageDiv w-100" [src]="documentData[0]?.image" alt="Image not available" />
					<div class="hover-overlay d-flex align-items-center justify-content-center position-absolute top-0 start-0 w-100 h-100 rounded-3" style="background: rgba(0,0,0,0.4); opacity: 0; transition: opacity 0.2s;" onmouseenter="this.style.opacity=1" onmouseleave="this.style.opacity=0">
						<span class="text-white bg-dark px-3 py-2 rounded-pill small d-flex align-items-center gap-2">
							<i class="pi pi-search-plus"></i> Click to Zoom & Move
						</span>
					</div>
				</div>
			</ng-template>

			<div class="modalFooter">
				<div class="button d-flex gap-3 mt-5 justify-content-end" *ngIf="documentData.length !== 0; else f3">
					<button class="cancelBtn" (click)="approveuser()"> Approve</button>
					<button class="saveBtn" (click)="rejectuser()"> Reject </button>
				</div>
				<ng-template #f3>
					<div class="button d-flex gap-3 mt-5 justify-content-end">
						<button class="cancelBtn mr-0" (click)="paymentType=false">Cancel</button>
						<button class="saveBtn" (click)="approveuser()"> Submit</button>
					</div>
				</ng-template>
			</div>

		</div>

	</form>
</p-dialog>

<p-dialog header="Document Rejection Form" [(visible)]="rejectDocument" [modal]="true" [style]="{ width: '400px' }"
	[draggable]="false" [resizable]="false" class="modal-payment-select" (onHide)="onRejectDocumentModalClose()"
	id="rejectionModal">
	<form [formGroup]="documentRejectForm">
		<div class="">
			<div class="">
				<label for="comment">
					Reason
				</label>
				<div class="">
					<textarea inputId="textarea" pInputTextarea rows="4" class="form-control"
						formControlName="comment"></textarea>
				</div>
				<div *ngIf="showCommentError">
					<div class="mandatory-fields">Please enter a reason.</div>
				</div>
			</div><br>

			<div class="modalFooter d-flex justify-content-center">
				<button class="saveBtn" (click)="submitRejectionForm()"> Submit </button>
			</div>
		</div>

	</form>
</p-dialog>

<p-dialog header="Rejection Reasons" [(visible)]="showRejectionList" [modal]="true" [draggable]="false"
	[style]="{width: '750px', height: 'auto'}" id="PoList">
	<p-table [value]="rejectedDocuments" styleClass="p-datatable-sm" class="DistributionTable">
		<ng-template pTemplate="header">
			<tr>
				<th class="documentTd" style="white-space: nowrap;">Document Image</th>
				<th class="DocumentType-Td">Document Type</th>
				<th class="ReasonTd">Reason</th>
				<th class="Date-Td">Date</th>
				<th class="RejectedTd">Rejected By</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-rejectedDocument let-index="rowIndex">
			<tr>
				<td class="documentTd imageTd cursor-pointer" (click)="openImagePreview(rejectedDocument?.image)">
					<img [src]="rejectedDocument?.image" alt="Image not available" />
				</td>
				<td class="DocumentType-Td">{{rejectedDocument?.type}}</td>
				<td class="ReasonTd">{{rejectedDocument?.comment}}</td>
				<td class="Date-Td">{{rejectedDocument?.rejected_at | date:'dd/MM/yyyy'}}</td>
				<td class="RejectedTd">{{rejectedDocument?.rejectedBy}}</td>
			</tr>
		</ng-template>
	</p-table>

</p-dialog>

<p-dialog header="Document Preview" [(visible)]="displayImagePreview" [modal]="true" [style]="{ width: '750px' }" [draggable]="false" [resizable]="false" appendTo="body" (onHide)="resetZoom()" id="customPreviewDialog">
	<div class="d-flex flex-column gap-3">
		<!-- Toolbar -->
		<div class="d-flex justify-content-between align-items-center p-2 rounded" style="border: 1px solid #ddd; background-color: #f8f9fa;">
			<div class="d-flex" style="gap: 8px;">
				<button type="button" style="border: 1px solid #bbb; background: #fff; padding: 6px 12px; border-radius: 6px; display: inline-flex; align-items: center; gap: 6px; cursor: pointer; font-size: 14px; font-weight: 500;" (click)="zoomIn()">
					<i class="pi pi-search-plus"></i> Zoom In
				</button>
				<button type="button" style="border: 1px solid #bbb; background: #fff; padding: 6px 12px; border-radius: 6px; display: inline-flex; align-items: center; gap: 6px; cursor: pointer; font-size: 14px; font-weight: 500;" (click)="zoomOut()">
					<i class="pi pi-search-minus"></i> Zoom Out
				</button>
				<button type="button" style="border: 1px solid #bbb; background: #fff; padding: 6px 12px; border-radius: 6px; display: inline-flex; align-items: center; gap: 6px; cursor: pointer; font-size: 14px; font-weight: 500;" (click)="resetZoom()">
					<i class="pi pi-refresh"></i> Reset
				</button>
			</div>
			<div style="font-size: 13px; color: #666; font-weight: 500;">
				Scroll to Zoom • Drag to Move
			</div>
		</div>

		<!-- Viewport -->
		<div class="image-viewport position-relative overflow-hidden d-flex align-items-center justify-content-center bg-dark rounded-3"
			 style="height: 500px; width: 100%; border: 1px solid #333; background-color: #1e1e1e;"
			 [style.cursor]="isDragging ? 'grabbing' : 'grab'"
			 (mousedown)="onMouseDown($event)"
			 (mousemove)="onMouseMove($event)"
			 (mouseup)="onMouseUp()"
			 (mouseleave)="onMouseUp()"
			 (wheel)="onWheel($event)">
			<img [src]="previewImageSrc" alt="Document Preview"
				 [style.transform]="'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomScale + ')'"
				 style="max-width: 100%; max-height: 100%; transition: transform 0.05s ease-out; user-select: none; pointer-events: none; transform-origin: center;" />
		</div>
	</div>
</p-dialog>

<p-overlayPanel #op ng styleClass="filterOverly">
	<ng-template pTemplate="content">
		<div class="d-flex flex-column gap-3 filters-list-div">
			<div *ngFor="let filterUser of userFilterByList" class="field-checkbox">
				<p-radioButton [inputId]="filterUser.key" name="filterUser" [value]="filterUser"
					(click)="onRadioButtonClick(filterUser)" [(ngModel)]="selectedFilter"></p-radioButton>
				<label [for]="filterUser.key" class="ml-2">{{ filterUser.name }}</label>
			</div>
		</div>
	</ng-template>
</p-overlayPanel>